<template>
  <div class="c-form-item-area-org">
    <el-cascader
      ref="cascaderRef"
      v-bind="cascaderAttrs"
      :modelValue="innerModelValue"
      :disabled="disabled"
      :props="innerCascaderProps"
      :options="orgOptions"
      @change="handleChange"
    ></el-cascader>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, watch, ref, useAttrs, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { getOrgsRef, loadOrgs, getOrgData } from './util'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    props: Array<any>
    disabled: boolean
    labelProps?: Array<any>
    relatedProps?: Array<any>
    checkStrictly: boolean
    cascaderProps?: Record<string, any>
  }>(),
  {
    disabled: false,
    checkStrictly: true
  }
)

const attrs = useAttrs()

const app = useCurrentAppInstance()

const cascaderRef = ref<any>()

const innerModelValue = ref<any>([])

const orgOptions = computed(() => getOrgsRef().value)

/** 级连查询属性 */
const innerCascaderProps = computed(() => {
  return {
    label: 'label',
    value: 'value',
    checkStrictly: props.checkStrictly,
    ...props.cascaderProps
  }
})

const innerProps = computed(() => {
  return props.props || []
})

const cascaderAttrs = computed(() => {
  return { collapseTags: true, placeholder: '请选择', separator: '-', ...attrs }
})

/** 大区Code */
const largeDeptCode = computed(() => {
  if (!innerProps.value[0]) return null
  return props.model[innerProps.value[0]]
})

// 监听largeDeptCode，处理清空问题
watch(
  () => largeDeptCode.value,
  () => {
    if (!largeDeptCode.value) {
      innerModelValue.value = []
    }

    innerProps.value.forEach((it: any) => {
      innerModelValue.value.push(props.model[it])
    })
  },
  { immediate: true }
)

onMounted(async () => {
  await loadOrgs(app)
})

// 修改时触发
function handleChange(vals: any) {
  const valsData = (vals || []).map((it: string) => {
    return getOrgData(it)
  })

  const _props = innerCascaderProps.value as any

  const valueProp = _props.value
  const labelProp = _props.label

  innerProps.value.forEach((it: any, index: number) => {
    props.model[it] = (valsData[index] || {})[valueProp]
  })

  // 获取值对应的label
  if (props.labelProps?.length) {
    props.labelProps.forEach((it: any, index: number) => {
      props.model[it] = (valsData[index] || {})[labelProp]
    })
  }
}
</script>
